import React from "react";
import {connect} from "react-redux";
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {Paper, Typography, Slider, TextField, Button} from "@material-ui/core";
import {INotificacion, IParcela} from "../../../types";
import moment from "moment";
import {ThemeProvider} from "@material-ui/styles";
import {createTheme} from "@material-ui/core/styles";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {resolucion_tablet} from "../../../tools/resolucion";

const config = require('../../../config.json');
const texts = require('../../../texts/riegoneto.json')


interface IProps {
    riego: Record<string, Record<string, number>>
    metodo: string
    parcelas: IParcela[]
    parcela: string
    notify(notification: INotificacion): void
    idioma: string
}

interface Istate {
    vertical: boolean
    hover: string
    parcela: IParcela
    dia_inicio: string
    dia_fin: string
    inicio: string
    fin: string
    cambiando: boolean
    riego_real: Record<string, number>
    riego_guardado: boolean
    text: Record<string, string>
}

class RiegoReal extends React.Component<IProps, Istate> {
    state: Istate = {
        vertical: window.matchMedia("(orientation: portrait)").matches,
        hover: '',
        parcela: {} as IParcela,
        dia_inicio: '',
        dia_fin: '',
        inicio: '',
        fin: '',
        cambiando: false,
        riego_real: {},
        riego_guardado: false,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        let parcela: IParcela = {}
        for (const element of this.props.parcelas) {
            if (element.id === this.props.parcela) {
                parcela = element
                this.setState({parcela: element})
                break
            }
        }

        const dias = parcela.dias.split(',')

        const hoy = (((new Date()).getDay() - 1) + 7) % 7
        let inicio = 0
        let final = 0

        for (let i = 0; i < 7; i++) {
            if (parseInt(dias[(hoy - i + 7) % 7]) === 1) {
                inicio = i
                break
            }
        }

        for (let i = 1; i < 8; i++) {
            if (parseInt(dias[(hoy + i + 7) % 7]) === 1) {
                final = i
                break
            }
        }

        const dia_inicio = moment(new Date(new Date().setDate(new Date().getDate()-inicio+1))).format('DD/MM/YYYY')
        const dia_fin = moment(new Date(new Date().setDate(new Date().getDate()+final))).format('DD/MM/YYYY')

        const inicio_str = moment(new Date(new Date().setDate(new Date().getDate()-inicio+1))).format('YYYY/MM/DD')
        const fin_str = moment(new Date(new Date().setDate(new Date().getDate()+final))).format('YYYY/MM/DD')

        this.setState({
            inicio: inicio_str,
            fin: fin_str
        })

        const n_dia_inicio = (new Date(new Date().setDate(new Date().getDate()-inicio+1))).getDay()
        const n_dia_fin = (new Date(new Date().setDate(new Date().getDate()+final))).getDay()

        const dias_semana = this.state.text["23"].split(",");

        this.setState({
            dia_inicio: dias_semana[n_dia_inicio] + " " + dia_inicio,
            dia_fin: dias_semana[n_dia_fin] + " " + dia_fin
        })


        const url: string = config.url+`/get/irrigation?parcela=${this.props.parcela}&inicio=${inicio_str}&fin=${fin_str}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                let riego = {} as Record<string, number>
                if (Object.keys(res.data).length === 0) {
                    for (let sector of Object.keys(this.props.riego[this.props.metodo])) {
                        const valor = this.props.riego[this.props.metodo][sector]
                        if (valor < 10)  riego[sector] = Math.round(valor*100)/100
                        if (10 <= valor && valor < 100)  riego[sector] = Math.round(valor*10)/10
                        if (100 <= valor && valor)  riego[sector] = Math.round(valor)
                    }
                    this.setState({riego_guardado: false})
                } else {
                    for (let sector of Object.keys(res.data)) {
                        const valor = res.data[sector]
                        if (valor < 10)  riego[sector] = Math.round(valor*100)/100
                        if (10 <= valor && valor < 100)  riego[sector] = Math.round(valor*10)/10
                        if (100 <= valor && valor)  riego[sector] = Math.round(valor)
                    }
                    this.setState({riego_guardado: true})
                }
                this.setState({riego_real: riego})
            })
            .catch(() => {
                this.props.notify({message: this.state.text["29"], variant: 'error'})
            })
    }

    handleSave = () => {
        axios.post(
            config.url+'/save/irrigation',
            {
                parcela: this.props.parcela,
                riego: this.state.riego_real,
                inicio: this.state.inicio,
                fin: this.state.fin
            },
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                this.props.notify({message: this.state.text["30"], variant: 'success'})
                this.setState({riego_guardado: true})

                const url: string = config.url+`/get/irrigation?parcela=${this.props.parcela}&inicio=${this.state.inicio}&fin=${this.state.fin}`
                axios.get(
                    url,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res) => {
                        let riego = {} as Record<string, number>
                        if (Object.keys(res.data).length === 0) {
                            for (let sector of Object.keys(this.props.riego[this.props.metodo])) {
                                const valor = this.props.riego[this.props.metodo][sector]
                                if (valor < 10)  riego[sector] = Math.round(valor*100)/100
                                if (10 <= valor && valor < 100)  riego[sector] = Math.round(valor*10)/10
                                if (100 <= valor && valor)  riego[sector] = Math.round(valor)
                            }
                        } else {
                            for (let sector of Object.keys(res.data)) {
                                const valor = res.data[sector]
                                if (valor < 10)  riego[sector] = Math.round(valor*100)/100
                                if (10 <= valor && valor < 100)  riego[sector] = Math.round(valor*10)/10
                                if (100 <= valor && valor)  riego[sector] = Math.round(valor)
                            }
                        }
                        this.setState({riego_real: riego})
                    })
                    .catch(() => {
                        this.props.notify({message: this.state.text["29"], variant: 'error'})
                    })


            })
            .catch(() => {
                this.props.notify({message: this.state.text["29"], variant: 'error'})
            })
    }


    renderRow = (row:string, max:number) => {

        const muiTheme = createTheme({
            overrides: {
                MuiSlider: {
                    thumb: {
                        color: "white",
                        width: 20,
                        height: 20,
                        borderStyle: "solid",
                        borderWidth:1,
                        marginTop: -10,
                        marginLeft: -10,
                        borderColor: "black"
                    },
                    rail: {
                        backgroundColor: "rgb(255,255,255)",
                        opacity: 100,
                        height: 20,
                        marginTop: -10
                    },
                    track: {
                        color: 'rgba(40,140,198,1)',
                        height: 20,
                        marginTop: -10,
                        borderRadius: 4
                    },
                    valueLabel: {
                        top: 0,
                        fontSize: 0,
                        '& *': {
                            background: 'transparent',
                            color: 'transparent',
                        },
                    },
                }
            }
        });

        return (
            <Paper
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    width: '94%',
                    backgroundColor: '#eee',
                    marginBottom: 15
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '100%',
                        marginLeft: 20
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            width: 'fit-content',
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                fontSize: 16,
                                marginRight: 10,
                                marginLeft: 20
                            }}
                        >
                            {this.state.text["20"]}
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                fontSize: 16,
                                marginRight: 10
                            }}
                        >
                            {row}
                        </Typography>
                    </div>
                    <Paper
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: 'rgb(161,208,238)',
                            height: 20,
                            marginTop: 5,
                            width: `${80*this.props.riego[this.props.metodo][row]/max}%`,
                        }}
                    />
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            height: 20,
                            marginTop: -20,
                        }}
                    >
                        {this.props.riego[this.props.metodo][row] < 1?
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    fontSize: 12
                                }}
                            >
                                <b>{this.state.text["31"]}:</b> {Math.round(this.props.riego[this.props.metodo][row]*100)/100} m³
                            </Typography>
                            :
                            this.props.riego[this.props.metodo][row] < 10?
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 10,
                                        fontSize: 12
                                    }}
                                >
                                    <b>{this.state.text["31"]}:</b> {Math.round(this.props.riego[this.props.metodo][row]*10)/10} m³
                                </Typography>
                                :
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 20,
                                        fontSize: 12
                                    }}
                                >
                                    <b>{this.state.text["31"]}:</b> {Math.round(this.props.riego[this.props.metodo][row])} m³
                                </Typography>
                        }

                    </div>
                    <ThemeProvider
                        theme={muiTheme}
                    >
                        <Slider
                            value={80*this.state.riego_real[row]/max}
                            onChange={(e, v) => {
                                let riego_real = this.state.riego_real
                                const nuevo_valor = v as number * (max/0.8)/100
                                if (nuevo_valor < 10) riego_real[row] = Math.round(nuevo_valor*100)/100
                                if (10 <= nuevo_valor && nuevo_valor < 100) riego_real[row] = Math.round(nuevo_valor*10)/10
                                if (100 <= nuevo_valor && nuevo_valor) riego_real[row] = Math.round(nuevo_valor)
                                this.setState({riego_real: riego_real})
                            }}
                        />
                    </ThemeProvider>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 200,
                        marginRight: 20,
                        marginBottom: 10
                    }}
                >
                    <div
                        style={{
                            width: 200,
                            marginLeft: 30,
                            backgroundColor: "white",
                            borderRadius: 6
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 12,
                                color: this.state.hover === row? '#000000' : '#747474',
                                fontWeight: this.state.hover === row? 'bold' : 'normal',
                                fontFamily: "Poppins",
                                marginLeft: 10
                            }}
                        >
                            {this.state.text["32"]}
                        </Typography>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: -5,
                                marginLeft: 10
                            }}
                        >
                            <TextField
                                style={{
                                    width: 180
                                }}
                                type="number"
                                value={this.state.riego_real[row]}
                                onChange={e => {
                                    let riego_real = this.state.riego_real
                                    riego_real[row] = parseFloat(e.target.value)
                                    this.setState({riego_real: riego_real})
                                }}
                                onMouseEnter={() => this.setState({hover: row})}
                                onMouseLeave={() => this.setState({hover: ''})}
                                InputProps={{ disableUnderline: true }}
                                inputProps={{style: {
                                        fontSize: 16,
                                        fontFamily: "Poppins",
                                        fontWeight: this.state.hover === row? 'bold' : 'normal',
                                    }}}
                                InputLabelProps={{style: {
                                        fontSize: 16,
                                        fontFamily: "Poppins",
                                        fontWeight: this.state.hover === row? 'bold' : 'normal',
                                }}}
                            />
                            <Typography
                                style={{
                                    marginLeft: -60,
                                    fontFamily: "Poppins",
                                    fontSize: 16,
                                    fontWeight: this.state.hover === row? 'bold' : 'normal',
                                }}
                            >
                                m³
                            </Typography>
                        </div>
                        <div
                            style={{
                                borderStyle: "solid",
                                borderTopWidth: this.state.hover === row? 2 : 1,
                                borderLeftWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderColor: this.state.hover === 'marco'? "black" : '#939393',
                                height: 0,
                                marginTop: -3,
                                marginLeft: 6,
                                marginRight: 6
                            }}
                        />
                    </div>

                </div>

            </Paper>
        )}


    renderRowV = (row:string, max:number) => {

        const muiTheme = createTheme({
            overrides: {
                MuiSlider: {
                    thumb: {
                        color: "white",
                        width: 20,
                        height: 20,
                        borderStyle: "solid",
                        borderWidth:1,
                        marginTop: -10,
                        marginLeft: -10,
                        borderColor: "black"
                    },
                    rail: {
                        backgroundColor: "rgb(255,255,255)",
                        opacity: 100,
                        height: 20,
                        marginTop: -10
                    },
                    track: {
                        color: 'rgba(40,140,198,1)',
                        height: 20,
                        marginTop: -10,
                        borderRadius: 4
                    },
                    valueLabel: {
                        top: 0,
                        fontSize: 0,
                        '& *': {
                            background: 'transparent',
                            color: 'transparent',
                        },
                    },
                }
            }
        });

        return (
            <Paper
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    width: '94%',
                    backgroundColor: '#eee',
                    marginBottom: 15
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '95%',
                        marginLeft: 15
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            width: 'fit-content',
                            marginTop: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                fontSize: 16,
                                marginRight: 10
                            }}
                        >
                            {this.state.text["20"]}
                        </Typography>
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "bold",
                                fontSize: 16,
                                marginRight: 10
                            }}
                        >
                            {row}
                        </Typography>
                    </div>
                    <Paper
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: 'rgb(161,208,238)',
                            height: 20,
                            marginTop: 5,
                            width: `${80*this.props.riego[this.props.metodo][row]/max}%`
                        }}
                    />

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            height: 20,
                            marginTop: -20
                        }}
                    >
                        {this.props.riego[this.props.metodo][row] < 1?
                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    fontSize: 12,
                                    width: window.innerWidth*0.8
                                }}
                            >
                                <b>Riego Neto Recomendado:</b> {Math.round(this.props.riego[this.props.metodo][row]*100)/100} m³
                            </Typography>
                            :
                            this.props.riego[this.props.metodo][row] < 10?
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 10,
                                        fontSize: 12,
                                        width: window.innerWidth*0.8
                                    }}
                                >
                                    <b>Riego Neto Recomendado:</b> {Math.round(this.props.riego[this.props.metodo][row]*10)/10} m³
                                </Typography>
                                :
                                <Typography
                                    style={{
                                        fontFamily: "Poppins",
                                        marginLeft: 20,
                                        fontSize: 12,
                                        width: window.innerWidth*0.8
                                    }}
                                >
                                    <b>Riego Neto Recomendado:</b> {Math.round(this.props.riego[this.props.metodo][row])} m³
                                </Typography>
                        }

                    </div>
                    <ThemeProvider
                        theme={muiTheme}
                    >
                        <Slider
                            value={80*this.state.riego_real[row]/max}
                            onChange={(e, v) => {
                                let riego_real = this.state.riego_real
                                const nuevo_valor = v as number * (max/0.8)/100
                                if (nuevo_valor < 10) riego_real[row] = Math.round(nuevo_valor*100)/100
                                if (10 <= nuevo_valor && nuevo_valor < 100) riego_real[row] = Math.round(nuevo_valor*10)/10
                                if (100 <= nuevo_valor && nuevo_valor) riego_real[row] = Math.round(nuevo_valor)
                                this.setState({riego_real: riego_real})
                            }}
                        />
                    </ThemeProvider>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: 200,
                        marginBottom: 10,
                        marginLeft: 15
                    }}
                >
                    <div
                        style={{
                            width: 200,
                            backgroundColor: "white",
                            borderRadius: 6
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 12,
                                color: this.state.hover === row? '#000000' : '#747474',
                                fontWeight: this.state.hover === row? 'bold' : 'normal',
                                fontFamily: "Poppins",
                                marginLeft: 10
                            }}
                        >
                            {this.state.text["32"]}
                        </Typography>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: -5,
                                marginLeft: 10
                            }}
                        >
                            <TextField
                                style={{
                                    width: 180
                                }}
                                type="number"
                                value={this.state.riego_real[row]}
                                onChange={e => {
                                    let riego_real = this.state.riego_real
                                    riego_real[row] = parseFloat(e.target.value)
                                    this.setState({riego_real: riego_real})
                                }}
                                onMouseEnter={() => this.setState({hover: row})}
                                onMouseLeave={() => this.setState({hover: ''})}
                                InputProps={{ disableUnderline: true }}
                                inputProps={{style: {
                                        fontSize: 16,
                                        fontFamily: "Poppins",
                                        fontWeight: this.state.hover === row? 'bold' : 'normal',
                                    }}}
                                InputLabelProps={{style: {
                                        fontSize: 16,
                                        fontFamily: "Poppins",
                                        fontWeight: this.state.hover === row? 'bold' : 'normal',
                                    }}}
                            />
                            <Typography
                                style={{
                                    marginLeft: -60,
                                    fontFamily: "Poppins",
                                    fontSize: 16,
                                    fontWeight: this.state.hover === row? 'bold' : 'normal',
                                }}
                            >
                                m³
                            </Typography>
                        </div>
                        <div
                            style={{
                                borderStyle: "solid",
                                borderTopWidth: this.state.hover === row? 2 : 1,
                                borderLeftWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderColor: this.state.hover === 'marco'? "black" : '#939393',
                                height: 0,
                                marginTop: -3,
                                marginLeft: 6,
                                marginRight: 6
                            }}
                        />
                    </div>

                </div>

            </Paper>
        )}



    render() {

        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);

        let max = 0
        for (let sector of Object.keys(this.props.riego[this.props.metodo])) {
            if (this.props.riego[this.props.metodo][sector] > max) max = this.props.riego[this.props.metodo][sector]
        }
        max = Math.round(max*100)/100

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: '100%'
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: this.state.vertical && !resolucion_tablet()? 20 : 30,
                        marginTop: 5,
                        width: '100%',
                    }}
                >
                    {this.state.text["32"]}
                </Typography>

                <Paper
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        borderRadius: 20,
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >

                    <Typography
                        style={{
                            fontSize: 16,
                            fontFamily: "Poppins",
                            margin: 30,
                            width: '94%'
                        }}
                    >
                        {this.state.text["33"]}
                        {this.state.dia_inicio}
                        {this.state.text["34"]}
                        {this.state.dia_fin}
                        {this.state.text["35"]}
                        <br/>
                        <br/>
                        {this.state.text["36"]}
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            margin: 30,
                            marginBottom: 10,
                            width: '94%',
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}
                    >

                        {this.state.riego_guardado?
                            <div/>
                            :
                            <Typography
                                style={{
                                    fontSize: 16,
                                    fontFamily: "Poppins",
                                    width: '80%',
                                    color: '#ff5b5b'
                                }}
                            >
                                {this.state.text["37"]} {this.state.dia_inicio} {this.state.text["18"]} {this.state.dia_fin}
                            </Typography>
                        }

                        <Button
                            variant={"contained"}
                            color={"primary"}
                            style={{
                                width: "fit-content",
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            onClick={() => this.handleSave()}
                        >
                            <Typography
                                style={{
                                    fontSize: 18,
                                    fontFamily: "Poppins",
                                    fontWeight: "bold",
                                    color: '#4C494B',
                                    margin: 8
                                }}
                            >
                                {this.state.text["38"]}
                            </Typography>
                        </Button>

                    </div>

                    {Object.keys(this.props.riego[this.props.metodo]).map(k =>
                        <div
                            key={k}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: '100%',
                                cursor: "pointer",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={() => {

                            }}
                        >
                            {!this.state.vertical ?
                                this.renderRow(k, max)
                                :
                                this.renderRowV(k, max)
                            }
                        </div>
                    )}
                    <div style={{margin: 20}}/>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    riego: state.riego.riego,
    metodo: state.riego.metodo,
    parcelas: state.principal.parcelas,
    parcela: state.navegacion.parcela,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification})
});

export default connect(mapStateToProps, mapDispatchToProps)(RiegoReal);